import { graphql } from "gql.tada";
import { LinkFragment } from "../fragments/LinkFragment";
import { IconGridFragment } from "../fragments/IconGridFragment";
import { RichTextFragment } from "../fragments/RichTextFragment";

export const SolutionsRowFragment = graphql(
  /* GraphQL */ `
    fragment SolutionsRowFragment on SolutionsChapterRow {
      _id
      sectionTitle
      rowType
      sectionTitleEyebrow
      collapsible
      bodyRichText {
        ...RichTextFragment
      }
    }
  `,
  [LinkFragment, RichTextFragment]
);

export const SolutionsChapterFragment = graphql(
  /* GraphQL */ `
    fragment SolutionsChapterFragment on SolutionsChapter {
      _id
      title
      eyebrow
      menuLabel
      media {
        url
        contentType
      }
      mediaSourceRichText {
        ...RichTextFragment
      }
      mediaBodyRichText {
        ...RichTextFragment
      }
      mediaHeading
      mediaLayout
      rowsCollection(limit: 10) {
        items {
          ...SolutionsRowFragment
        }
      }
    }
  `,
  [SolutionsRowFragment, IconGridFragment, RichTextFragment]
);

export const SolutionsSectionById = graphql(
  /* GraphQL */ `
    query SolutionsSectionById(
      $locale: String
      $preview: Boolean
      $id: String!
    ) {
      solutionsSection(id: $id, preview: $preview, locale: $locale) {
        _id
        title
        chaptersCollection(limit: 6) {
          items {
            ...SolutionsChapterFragment
          }
        }
      }
    }
  `,
  [SolutionsChapterFragment]
);
